'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var JSON = _interopDefault(require('json-cycle'));

function memorizeOne(fn) {
  const map = new Map();
  return (...args) => {
    const argstr = JSON.stringify(args);
    let result = map.get(argstr);

    if (!result) {
      result = fn(...args);
      map.set(argstr, result);
    }

    return result;
  };
}

module.exports = memorizeOne;
